import { DuplicateIcon } from "@components/icons";
import { Button } from "@nextui-org/button";
import { commonLittleBtnClasses } from "./commonLittleBtnClasses";

export function DuplicateButton({ children, className, iconClassName = "size-5 sm:size-6", iconColor = "currentcolor", ...props }) {
    return (
        <Button {...props} className={`${commonLittleBtnClasses} ${className}`} data-hover={false} >
            <DuplicateIcon className={iconClassName} color={iconColor} />
        </Button>
    )
}


